export const DELAY_COURSE_CARD_QUICK_VIEW_BOX = 'delay_course_card_quick_view_box';
export const HIDE_WISHLIST_BUTTON_ON_COURSE_CARD_QUICK_VIEW_BOX =
    'hide_wishlist_button_on_course_card_quick_view_box';
export const COURSE_CARDS_OPEN_IN_NEW_TAB = 'course_cards_open_in_new_tab';
export const POPULAR_CATEGORIES_MODULE = 'popular_categories_module';
export const COURSE_GUIDANCE_FEATURE = 'course_guidance_feature';
export const LEARNERS_ARE_VIEWING_ON_LOHP = 'learners_are_viewing_on_lohp';
export const SHOW_TRENDING_SKILLS_ABOVE_AI_ERA_CAREER_BANNER =
    'show_trending_skills_above_ai_era_career_banner';
export const DESKTOP_POST_ADD_TO_CART_BEHAVIOR = 'desktop_post_add_to_cart_behavior';
export const CAREER_ACADEMIES = 'career_academies';
export const MOBILE_WEB_OPTIMIZATION = 'mobile_web_optimization';
export const POPULAR_CATEGORIES_MODULE_FOR_LOHP = 'popular_categories_module_for_lohp';
export const LOHP_VERTICAL_MOBILE_RECO_UNITS = 'lohp_vertical_mobile_reco_units';
export const FBT_FORCE_GO_TO_CART = 'fbt_force_go_to_cart';
export const SHOW_VERNACULAR_CONTENT = 'show_vernacular_content';
export const MOBILE_WEB_LOHP_TOPIC_CAROUSEL = 'mobile_web_lohp_topic_carousel';
export const MWEB_SEARCH_HEADER_OPTIMIZATION = 'mweb_search_header_optimization';
export const MOVE_REMOVE_GWG_FROM_LOHP = 'move_remove_gwg_from_lohp';
export const LOHP_HERO_BANNER_CONSOLIDATED = 'lohp_hero_banner_consolidated';
